import { gql } from '@apollo/client'

export const FIND_ALL_GAME_CHALLENGES = gql`
  query findAllGameChallenge($query: GameChallengeQueryInput!) {
    findAllGameChallenge(query: $query) {
      count
      items {
        id
        createdAt
        updatedAt
        deletedAt
        version
        type
        description
      }
    }
  }
`

export const UPDATE_GAME_CHALLENGE = gql`
  mutation updateGameChallenge($updateGameChallengeInputFieldName: UpdateGameChallengeInput!) {
    updateGameChallenge(updateGameChallengeInputFieldName: $updateGameChallengeInputFieldName) {
      id
      description
    }
  }
`
